var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{attrs:{"header":"true","header-tag":"header"}},[_c('div',{staticClass:"d-flex justify-content-between align-items-center",attrs:{"slot":"header"},slot:"header"},[_c('p',{staticClass:"mb-0 d-inline-block align-middle"},[_c('b',[_vm._v(_vm._s(_vm.title))])])]),_vm._v(" "),_c('div',{staticClass:"details-card custom-grid-wrapper"},[_vm._l((_vm.rows),function(row,index){return [_c('div',{key:`label_${index}`,class:{
          even: index % 2 === 0,
          odd: index % 2 !== 0,
          'grid-item-label': true,
        }},[_c('strong',[_vm._v(_vm._s(row.label.toUpperCase()))])]),_vm._v(" "),_c('div',{key:`value_${index}`,class:{
          even: index % 2 === 0,
          odd: index % 2 !== 0,
          'grid-item-value': true,
        },domProps:{"innerHTML":_vm._s(row.value)}})]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }